/*
 * 產品頁揀款：揀咗邊個物料 / 功能，就喺嗰組掣下面講一句佢係乜（sections/main-product.liquid variant_picker 嘅 option_hints）
 *
 *   物料
 *   [寵物布] [生態牛皮] [生態全皮] [A級半皮]
 *   寵物友善布料：防油、防水、防污，耐磨 25,000+ 轉…   ← 客猶豫嗰一刻就答佢（唔使捲落頁底 accordion 搵）
 *
 *   option_hints 一行一條「關鍵字｜解釋」，選項值包含關鍵字就出（由上而下，第一條中嘅先算）。
 *   例如「半皮｜…」同時對到 A級半皮 / C級半皮；「電動頭枕+腰枕｜…」對到「6電動(電動頭枕+腰枕+腳鉸）」同「六電動(…)」。
 *
 *   ImOptionHints（純函數，tests/ux-nudges.cjs 測）：
 *     parse(text)          → [[關鍵字, 解釋], …]
 *     hintFor(rules, value) → 解釋 / ''
 */
(function (root) {
  function parse(text) {
    return String(text || '')
      .split(/\r?\n/)
      .map(function (line) {
        var parts = line.split('｜');
        return [String(parts[0] || '').trim(), parts.slice(1).join('｜').trim()];
      })
      .filter(function (rule) { return rule[0] && rule[1]; });
  }

  function hintFor(rules, value) {
    value = String(value || '');
    for (var i = 0; i < rules.length; i++) {
      if (value.indexOf(rules[i][0]) > -1) return rules[i][1];
    }
    return '';
  }

  root.ImOptionHints = { parse: parse, hintFor: hintFor };
})(typeof window !== 'undefined' ? window : this);

(function () {
  if (typeof document === 'undefined') return;
  var H = window.ImOptionHints;

  function initialize(root) {
    // 解釋放喺 data-option-hints attribute：唔可以用 <script type="application/json">，
    // Dawn / im-option-groups / im-pdp-resume 都係攞 picker 入面第一個 application/json 當 variants
    root.querySelectorAll('variant-radios[data-option-hints]').forEach(function (picker) {
      if (picker.dataset.imHintsReady) return;
      var rules = H.parse(picker.getAttribute('data-option-hints'));
      if (!rules.length) return;

      function sync() {
        picker.querySelectorAll('fieldset').forEach(function (fieldset) {
          var el = fieldset.querySelector('[data-option-hint]');
          if (!el) return;
          var checked = fieldset.querySelector('input[type="radio"]:checked');
          var text = checked ? H.hintFor(rules, checked.value) : '';
          el.textContent = text;
          el.hidden = !text;
        });
      }

      // im-option-groups 可能會自動轉選項 → 等佢轉完先讀
      picker.addEventListener('change', function () { setTimeout(sync, 0); });
      picker.dataset.imHintsReady = 'true';
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
